<svg
  [style.opacity]="opacity"
  [ngClass]="classes"
  class="st0"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 512 512"
>
  <style type="text/css">
    .st0 path {
      fill: {{ color }};
    }
  </style>

  <g [ngSwitch]="type">
    <!-- Pin -->
    <g *ngSwitchCase="'pricePin'">
      <g transform="translate(0 -20) scale(1,1.1)">
        <path
          style="fill: #ffffff !important"
          d="M258.8,470.2l-70.1-71.4l-1.5-1.5H185H21.6V162.6h468.8v234.7H336.7h-2.1l-1.5,1.4L258.8,470.2z"
        />
        <path
          style="fill: #e3530d !important"
          d="M26.7,167.8v224.4H185h4.3l3,3.1l66.5,67.8l70.7-68l3-2.9h4.1h148.5V167.8H26.7 M16.5,157.5h479.1v245H336.7
                    l-78.1,75l-73.6-75H16.5V157.5z"
        />
        <text
          style="
            fill: #e3530d;
            font-size: 150px;
            font-weight: bold;
            font-family: proxima-nova, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
          "
          x="50%"
          y="62%"
          text-anchor="middle"
        >
          {{ string }}
        </text>
      </g>
    </g>

    <g *ngSwitchCase="'pricePinFilled'">
      <g transform="translate(0 -20)">
        <path d="M258.8,451.9l-70.1-71.4l-1.5-1.5H185H21.6V144.3h468.8V379H336.7h-2.1l-1.5,1.4L258.8,451.9z" />
        <path
          d="M26.7,149.5v224.4H185h4.3l3,3.1l66.5,67.8l70.7-68l3-2.9h4.1h148.5V149.5H26.7 M16.5,139.2h479.1v245H336.7
                    l-78.1,75l-73.6-75H16.5V139.2z"
        />
        <text
          style="
            fill: #ffffff;
            font-size: 150px;
            font-weight: bold;
            font-family: proxima-nova, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
          "
          x="50%"
          y="62%"
          text-anchor="middle"
        >
          {{ string }}
        </text>
      </g>
    </g>

    <g *ngSwitchCase="'pin'">
      <g transform="matrix(22.180789,0,0,21.375,-1600.6861,0)">
        <path
          d="m 84,0 a 8.237,8.237 0 0 0 -8,8.438 8.765,8.765 0 0 0 1.194,4.437 l 6.35,10.793 A 0.66,0.66 0 0 0 84.11,24 h 0.005 a 0.661,0.661 0 0 0 0.567,-0.342 l 6.189,-10.9 A 8.779,8.779 0 0 0 92,8.438 8.237,8.237 0 0 0 84,0 Z m 5.727,12.038 -5.627,9.908 -5.774,-9.813 a 7.31,7.31 0 0 1 -1,-3.7 6.683,6.683 0 1 1 13.347,0 7.318,7.318 0 0 1 -0.946,3.605 z"
        />
        <path
          d="m 170.25,90 a 4.25,4.25 0 1 0 4.25,4.25 4.255,4.255 0 0 0 -4.25,-4.25 z m 0,7.093 a 2.843,2.843 0 1 1 2.838,-2.843 2.845,2.845 0 0 1 -2.838,2.843 z"
          transform="translate(-86.25,-85.798)"
        />
      </g>
    </g>

    <g *ngSwitchCase="'boondockPin'">
      <g transform="matrix(20.64,0,0,20.64142,-14298.502,-9726.1066)">
        <path
          d="m 76.573,0 a 5.907,5.907 0 0 0 -6,5.795 c 0,3.965 5.369,9.786 5.6,10.032 a 0.553,0.553 0 0 0 0.8,0 c 0.229,-0.246 5.6,-6.067 5.6,-10.032 A 5.907,5.907 0 0 0 76.573,0 Z"
          transform="translate(628.587,480)"
        />
      </g>
    </g>

    <g *ngSwitchCase="'boondockPinSmall'">
      <g transform="matrix(15.5,0,0,15.501066,-10673.98,-7176.5007)">
        <path
          d="m 76.573,0 a 5.907,5.907 0 0 0 -6,5.795 c 0,3.965 5.369,9.786 5.6,10.032 a 0.553,0.553 0 0 0 0.8,0 c 0.229,-0.246 5.6,-6.067 5.6,-10.032 A 5.907,5.907 0 0 0 76.573,0 Z"
          transform="translate(628.587,480)"
        />
      </g>
    </g>

    <g *ngSwitchCase="'boondockPinLarge'">
      <g transform="matrix(24,0,0,24.001651,-16667.84,-11392.775)">
        <path
          d="m 76.573,0 a 5.907,5.907 0 0 0 -6,5.795 c 0,3.965 5.369,9.786 5.6,10.032 a 0.553,0.553 0 0 0 0.8,0 c 0.229,-0.246 5.6,-6.067 5.6,-10.032 A 5.907,5.907 0 0 0 76.573,0 Z"
          transform="translate(628.587,480)"
        />
      </g>
    </g>
  </g>
</svg>
